module.exports = __webpack_public_path__ + "img/parallax2-450p.b725ea4e.jpg";